import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import SummaryApi from '../common'
import { useSelector } from 'react-redux'
import ROLE from '../common/role'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import AdminCosmeticVerticalCard from '../components/AdminCosmeticVerticalCard'

const AdminCosmeticCategoryProduct = () => {
    const [data,setData] = useState([])
    const navigate = useNavigate()
    const [loading,setLoading] = useState(false)
    const location = useLocation()
    const urlSearch = new URLSearchParams(location.search)
    const urlCategoryListinArray = urlSearch.getAll("category")
    const [productCategory,setProductCategory] = useState([])
    const user = useSelector(state => state?.user?.user);
    

    const getDistinctCategories = async (userType) => {
      const response = await fetch(SummaryApi.getDistinctCategories.url, {
        method: SummaryApi.getDistinctCategories.method ,
        credentials: 'include',
        headers: {
          "Content-Type": 'application/json'
        },
        body: JSON.stringify({ userType }) 
      });
    
      const responseData = await response.json();
    
      if (responseData.success) {
        setProductCategory(responseData.data); // Assuming this sets the categories
      } 
    };
    
  
  

    const urlCategoryListObject = {}
    urlCategoryListinArray.forEach(el =>{
      urlCategoryListObject[el] = true
    })

    const [selectCategory,setSelectCategory] = useState(urlCategoryListObject)
    const [filterCategoryList,setFilterCategoryList] = useState([])

    const [sortBy,setSortBy] = useState("")

    const fetchData = async()=>{
      const response = await fetch(SummaryApi.filterProduct.url,{
        method : SummaryApi.filterProduct.method,
        headers : {
          "content-type" : "application/json"
        },
        body : JSON.stringify({
          category : filterCategoryList,
          type : "Cosmetic"
        })
      })

      const dataResponse = await response.json()
      setData(dataResponse?.data || [])
    }

    const handleSelectCategory = (e) =>{
      const {name , value, checked} =  e.target

      setSelectCategory((preve)=>{
        return{
          ...preve,
          [value] : checked
        }
      })
    }

    useEffect(()=>{
      setLoading(true)
      getDistinctCategories("Cosmetic");
      setLoading(false)
      fetchData()
    },[filterCategoryList])

    useEffect(()=>{
      const arrayOfCategory = Object.keys(selectCategory).map(categoryKeyName =>{
        if(selectCategory[categoryKeyName]){
          return categoryKeyName
        }
        return null
      }).filter(el => el)

      setFilterCategoryList(arrayOfCategory)

      //format for url change when change on the checkbox
      const urlFormat = arrayOfCategory.map((el,index) => {
        if((arrayOfCategory.length - 1 ) === index  ){
          return `category=${el}`
        }
        return `category=${el}&&`
      })

      navigate("/admin-cosmetic-category-product?"+urlFormat.join(""))
    },[selectCategory])


    const handleOnChangeSortBy = (e)=>{
      const { value } = e.target

      setSortBy(value)

      if(value === 'asc') {
        setData(preve => 
          preve.sort((a, b) => {
            const priceA = a.sellingPrice === 0 || null ? a.price : a.sellingPrice;
            const priceB = b.sellingPrice === 0 || null ? b.price : b.sellingPrice;
            return priceA - priceB;
          })
        );
      }
      
      if(value === 'dsc') {
        setData(preve => 
          preve.sort((a, b) => {
            const priceA = a.sellingPrice === 0 || null ? a.price : a.sellingPrice;
            const priceB = b.sellingPrice === 0 || null ? b.price : b.sellingPrice;
            return priceB - priceA;
          })
        );
      }
      
    }

    useEffect(() => {
      setLoading(true);
      const loadingTimeout = setTimeout(() => {
        
        setLoading(false);
        navigate("/");
      }, 10000); 
  
      if (user) {
        if (user?.role !== ROLE.ADMIN ) {
          
          navigate("/");
          setLoading(false);
        } 
        else if(user?.type==="Medicine"){
          navigate('/admin-home')
          setLoading(false);

        }
        else if(user?.type==="Admin"){
          navigate('/admin-panel/all-users');
          setLoading(false);
  
        }
        else {
          setLoading(false);
          clearTimeout(loadingTimeout)
        }
      } 
  
      // Clear the timeout when the component unmounts or the effect is rerun
      return () => clearTimeout(loadingTimeout);
    }, [sortBy,user, navigate]);
  

    if (loading) {
      return (
        <div className="flex justify-center items-center h-screen">
          <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
        </div>
      );
    }
    
  return (
    <div className='container mx-auto p-4'>

       {/***desktop version */}
       <div className='hidden lg:grid grid-cols-[200px,1fr]'>
           {/***left side */}
           <div className='bg-white p-2 min-h-[calc(100vh-120px)] overflow-y-scroll'>
                {/**sort by */}
                <div className=''>
                    <h3 className='text-base uppercase font-medium text-slate-500 border-b pb-1 border-slate-300'>ترتيب حسب</h3>

                    <form className='text-sm flex flex-col gap-2 py-2'>
                        <div className='flex items-center gap-3'>
                          <input type='radio' name='sortBy' checked={sortBy === 'asc'} onChange={handleOnChangeSortBy} value={"asc"}/>
                          <label>السعر - من الأقل إلى الأعلى</label>
                        </div>

                        <div className='flex items-center gap-3'>
                          <input type='radio' name='sortBy' checked={sortBy === 'dsc'} onChange={handleOnChangeSortBy} value={"dsc"}/>
                          <label>السعر - من الأعلى إلى الأقل</label>
                        </div>
                    </form>
                </div>


                {/**filter by */}
                <div className=''>
                    <h3 className='text-base uppercase font-medium text-slate-500 border-b pb-1 border-slate-300'>العلامة التجارية</h3>

                    <form className='text-sm flex flex-col gap-2 py-2'>
                        {
                          productCategory.map((categoryName,index)=>{
                            return(
                              <div className='flex items-center gap-3'>
                                 <input type='checkbox' name={"category"} checked={selectCategory[categoryName?.value]} value={categoryName?.value} id={categoryName?.value} onChange={handleSelectCategory} />
                                 <label htmlFor={categoryName?.value}>{categoryName?.label}</label>
                              </div>
                            )
                          })
                        }
                    </form>
                </div>


           </div>


            {/***right side ( product ) */}
            <div className='px-4'>
              <p className='font-medium text-slate-800 text-lg my-2'>نتائج البحث : {data.length}</p>

             <div className='min-h-[calc(100vh-120px)] overflow-y-scroll max-h-[calc(100vh-120px)]'>
              {
                  data.length !== 0 && !loading && (
                    <AdminCosmeticVerticalCard userType ={"Cosmetic"} data={data} loading={loading}/>
                  )
              }
             </div>
            </div>
       </div>
       
    </div>
  )
}

export default AdminCosmeticCategoryProduct